import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http'
import { inject } from '@angular/core'
import { finalize } from 'rxjs'

import { LoaderService } from '../services/loader.service'

export const loaderInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
	const loader = inject(LoaderService)
	const filterList: string[] = [
		'/sb/bm/event',
		'/sb/fancy/event',
		'/service_config/maintenance',
		'/bf/market_status',
		'/market/status',
		'/bf/next-race/',
		'/bf/place-bet',
	]
	const shouldIgnore = filterList.some((url) => req.url.includes(url))

	if (!shouldIgnore && String(req.url).startsWith('https')) {
		loader.setLoading(req.url, true)
	}

	return next(req).pipe(
		finalize(() => {
			if (!shouldIgnore) {
				loader.setLoading(req.url, false)
			}
		}),
	)
}
